module.exports = __webpack_public_path__ + "img/inner-mask.adc44ce8.png";